export const apiConstants = {
  // URL: "http://api.careculinair.test/",
  URL: "https://api.wastewijzer.nl/", // Localhost
};
